import { render, staticRenderFns } from "./RelatorioRecebimentos.vue?vue&type=template&id=4f6a28cc&"
import script from "./RelatorioRecebimentos.vue?vue&type=script&lang=js&"
export * from "./RelatorioRecebimentos.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioRecebimentos.vue?vue&type=style&index=0&id=4f6a28cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports